export enum EventType {
  schedule = 'schedule',
  timesheet = 'timesheet'
}
